export enum Sector {
    Construction = 'Bouw',
    Logistics = 'Logistiek',
    Industry = 'Industrie',
    Care = 'Zorg',
    Education = 'Onderwijs',
    Office = 'Kantoor',
    Chemical = 'Chemie',
    MKB = 'MKB'
}
